// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React, { useContext } from 'react';
import { Action } from '@op/opds.opux';
import { IconDownload } from '@op/opds.opux-icons/action';
import { agreementTypes, getPdf } from '../../components/PdfHandler';
import message from '../../messages';
import { ContextWrapper } from '../../context/ContextWrapper';

interface PdfState {
    isLoading: boolean;
    error: boolean;
}

interface DownloadPdfButtonProps {
    setPdfState: React.Dispatch<React.SetStateAction<PdfState>>;
}

const DownloadPdfButton: React.FC<DownloadPdfButtonProps> = ({ setPdfState }) => {
    const { isAdminFlow } = useContext(ContextWrapper);
    return (
        <Action
            id="pdfLinkTwo"
            className="pdf-download"
            data-testid="pdfDownloadButton"
            icon={IconDownload}
            iconPos="right"
            onClick={() => {
                setPdfState({ isLoading: true, error: false });
                getPdf(agreementTypes.manualSigning, setPdfState, true);
            }}
        >
            {isAdminFlow ? message('pdfLinkIsAdminFlow') : message('pdfLink')}
        </Action>
    );
};

export default DownloadPdfButton;
